import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {

    this.setState({ error, errorInfo });
  }

  render() {
    const { hasError, error } = this.state;
    const { DefaultFallbackComponent } = this.props;

    if (hasError) {
      return DefaultFallbackComponent ? (
        <DefaultFallbackComponent error={error} />
      ) : (
        <div
          style={{
            padding: "1rem",
            backgroundColor: "#ffe0e0",
            color: "#b00020",
            borderRadius: "5px",
          }}
        >
          <h2>Something went wrong.</h2>
          <p>{error ? error.toString() : "Unknown error occurred."}</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "0.5rem 1rem",
              backgroundColor: "#b00020",
              color: "#fff",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

export const DefaultFallbackComponent = (props) => (
  <div>We are sorry but something went wrong. Please retry later.</div>
);
